(function () {
  'use strict';
  if (window.__LP_FREE_MAGNET__) return;
  window.__LP_FREE_MAGNET__ = true;

  // MageWorx APO renders the gift cards as .mw-option__value blocks whose
  // titles use .mw-stack--wide__content-title. The free magnet card has no
  // price line, while the paid gifts show "+$xx.00" right below the title.
  var GIFT_TITLE_SELECTOR = '.mw-stack--wide__content-title';
  var FREE_TITLES = ['Matching Magnet', 'Custom Engraved Necklace'];
  var FREE_CLASS = 'lp-free-magnet__free';

  function isMagnetCard(card) {
    // The cart's APO edit modal reuses the same markup; leave it untouched.
    if (card.closest('.mw-tingle')) return false;
    var title = card.querySelector(GIFT_TITLE_SELECTOR);
    if (!title || FREE_TITLES.indexOf(title.textContent.trim()) < 0) return false;
    if (!card.querySelector('input[type="radio"], input[type="checkbox"]')) return false;
    // Only treat this as the free gift when it sits in the Matching Pet Gifts
    // group. A normal product option that happens to be called "Matching
    // Magnet" would not have the sibling gift titles.
    var container = card.closest('.mw-option__container');
    if (!container) return false;
    var siblings = 0;
    container.querySelectorAll(GIFT_TITLE_SELECTOR).forEach(function (node) {
      if (/^Matching\s+/i.test(node.textContent.trim())) siblings += 1;
    });
    return siblings >= 1;
  }

  function enhance() {
    document.querySelectorAll('.mw-option__value').forEach(function (card) {
      if (!isMagnetCard(card)) return;
      var content = card.querySelector('.mw-stack--wide__content');
      var titleRow = content && content.querySelector('.mw-stack--wide__content-title--row');
      if (!content || !titleRow) return;
      if (content.querySelector('.' + FREE_CLASS)) return;

      // Reuse the price line's class so the label lands in exactly the same
      // slot as the paid cards' "+$xx.00", keeping the grid heights aligned.
      var price = document.createElement('div');
      price.className = 'mw-stack--wide__content-price ' + FREE_CLASS;
      var text = document.createElement('span');
      text.className = 'mw-text';
      text.textContent = 'Free Now!';
      price.append(text);
      titleRow.after(price);
    });
  }

  var frame;
  function schedule() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(enhance);
  }

  // APO hydrates the option cards after this script runs and may re-render
  // them when selections change, so keep watching for missing labels.
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  enhance();
})();
